import React, { Children } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ArrowLeft, Laptop, Code, Lightbulb, HandHeart, GraduationCap, Heart } from 'lucide-react';
export function AnseCanotPage() {
  return <div className="min-h-screen font-sans" style={{
    backgroundColor: '#0D121D'
  }} data-id="element-143" data-mp="1j5zs1tfintng">
      <Header data-id="element-144" data-mp="qf7xf0e3nd28" />

      <main data-id="element-145" data-mp="qfq3eoqkd5nc">
        {/* Hero Section */}
        <section className="relative pt-32 pb-20 overflow-hidden" data-id="element-146" data-mp="qgsrkowi4tzk">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-147" data-mp="vf2nx2tyq0mr">
            <a href="/saint-lucia" className="inline-flex items-center text-slate-300 hover:text-white transition-colors mb-12" data-id="element-148" data-mp="zfwds1qytpia">
              <ArrowLeft className="w-5 h-5 mr-2" data-id="element-149" data-mp="14cmtgnyuyj36" />
              Back to Saint Lucia
            </a>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-150" data-mp="2aww790p1uadw">
              {/* Text */}
              <div data-id="element-151" data-mp="2fvpgggxazf89">
                <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-emerald-500/20 border border-emerald-400/30 text-emerald-300 text-sm font-bold mb-6 uppercase tracking-wider" data-id="element-152" data-mp="38okktrxgtg50">
                  <HandHeart className="w-4 h-4" data-id="element-153" data-mp="2ypbst4m5ubla" />
                  Community Outreach
                </div>

                <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-white mb-6 leading-tight" data-id="element-154" data-mp="2trjqrhrsx93d">
                  Anse Canot
                  <br data-id="element-155" data-mp="2pqht35dj953i" />
                  <span className="text-emerald-400" data-id="element-156" data-mp="2kyghllo6viej">
                    Community Outreach Foundation
                  </span>
                </h1>

                <p className="text-xl text-slate-300 leading-relaxed mb-6" data-id="element-157" data-mp="2g059pghgfhyy">
                  Empowering the next generation of Saint Lucia by giving our
                  children the tools, knowledge, and confidence to thrive in a
                  digital world.
                </p>

                <p className="text-lg text-slate-400 leading-relaxed" data-id="element-158" data-mp="220ndig1tx2fk">
                  We believe every child deserves the opportunity to learn,
                  create, and lead — no matter where they grow up.
                </p>
              </div>

              {/* Image */}
              <div className="relative" data-id="element-159" data-mp="1iec2c97edh2h">
                <div className="absolute -inset-4 bg-emerald-400/20 blur-3xl rounded-full" data-id="element-160" data-mp="1ifdigs39str2" />
                <div className="relative rounded-3xl overflow-hidden border-2 border-emerald-500/30 shadow-2xl" data-id="element-161" data-mp="1ndf9bz6xtxd3">
                  <img src="https://cdn.magicpatterns.com/uploads/7uNz2ua1otGtYqp5kJX3Ki/chXa9.jpg" alt="Children of the Anse Canot community" className="w-full h-auto" data-id="element-162" data-mp="2b39j27vyn5t4" />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Mission Section */}
        <section className="py-20" data-id="element-163" data-mp="2u0apzy92rfzp">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-164" data-mp="2tz95l3665h5b">
            <div className="bg-white/5 backdrop-blur rounded-3xl border border-emerald-500/20 p-10 md:p-14 text-center" data-id="element-165" data-mp="2ysu54zneuj6m">
              <div className="w-16 h-16 rounded-full bg-emerald-400/20 flex items-center justify-center mx-auto mb-6" data-id="element-166" data-mp="38519hxmvjbf7">
                <Heart className="w-8 h-8 text-emerald-300" data-id="element-167" data-mp="3hwnw0q4nwwx9" />
              </div>
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-168" data-mp="3hyrwsz79lftb">
                Our Mission
              </h2>
              <p className="text-lg md:text-xl text-slate-300 leading-relaxed" data-id="element-169" data-mp="2p802665ukz83">
                To build up the children of our community by introducing them to
                the world of{' '}
                <span className="text-emerald-300 font-semibold" data-id="element-170" data-mp="2z6676wmyalh6">
                  technology
                </span>{' '}
                and{' '}
                <span className="text-emerald-300 font-semibold" data-id="element-171" data-mp="2u6bgou737xwn">
                  digital skills
                </span>
                . We're creating pathways where curiosity meets opportunity, so
                that every young mind in Anse Canot can dream bigger and reach
                further.
              </p>
            </div>
          </div>
        </section>

        {/* Focus Areas */}
        <section className="pb-20" data-id="element-172" data-mp="2k50oajjayqss">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-173" data-mp="2k62a9j1uwxpa">
            <div className="text-center mb-12" data-id="element-174" data-mp="2p1r3l4na9id5">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-3" data-id="element-175" data-mp="2t4nrnavle6oh">
                What We Focus On
              </h2>
              <p className="text-lg text-slate-400" data-id="element-176" data-mp="2y2z1vmpsuj78">
                Building tomorrow's innovators, one skill at a time
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-177" data-mp="37ttmkmnedaqk">
              <div className="bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 hover:border-emerald-400/50 transition-colors p-8 text-center" data-id="element-178" data-mp="37vwljw6j2e7f">
                <div className="w-14 h-14 rounded-full bg-emerald-400/20 flex items-center justify-center mx-auto mb-5" data-id="element-179" data-mp="3gvjdlrdda7nt">
                  <Laptop className="w-7 h-7 text-emerald-300" data-id="element-180" data-mp="3ltunu37kqk6k" />
                </div>
                <h3 className="text-xl font-bold text-white mb-2" data-id="element-181" data-mp="1a70wcibw82m1">
                  Tech Literacy
                </h3>
                <p className="text-slate-400 text-sm" data-id="element-182" data-mp="155tros51rjjl">
                  Introducing kids to computers, the internet, and the digital
                  tools that shape our world.
                </p>
              </div>

              <div className="bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 hover:border-emerald-400/50 transition-colors p-8 text-center" data-id="element-183" data-mp="w8t1cfyf3bdi">
                <div className="w-14 h-14 rounded-full bg-emerald-400/20 flex items-center justify-center mx-auto mb-5" data-id="element-184" data-mp="1owfa02mi5678">
                  <Code className="w-7 h-7 text-emerald-300" data-id="element-185" data-mp="1k2azxahxwi1x" />
                </div>
                <h3 className="text-xl font-bold text-white mb-2" data-id="element-186" data-mp="1f4sy042cb33f">
                  Digital Skills
                </h3>
                <p className="text-slate-400 text-sm" data-id="element-187" data-mp="2cmsyjj5vomx2">
                  Hands-on lessons in coding, creating, and using technology to
                  solve real problems.
                </p>
              </div>

              <div className="bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 hover:border-emerald-400/50 transition-colors p-8 text-center" data-id="element-188" data-mp="2vpbn7e9c20yp">
                <div className="w-14 h-14 rounded-full bg-emerald-400/20 flex items-center justify-center mx-auto mb-5" data-id="element-189" data-mp="2hxeylk6vi972">
                  <Lightbulb className="w-7 h-7 text-emerald-300" data-id="element-190" data-mp="2lxfc92m5egd2" />
                </div>
                <h3 className="text-xl font-bold text-white mb-2" data-id="element-191" data-mp="27yfp5zeaa9j0">
                  Creative Thinking
                </h3>
                <p className="text-slate-400 text-sm" data-id="element-192" data-mp="1yz2e52aihcw6">
                  Encouraging curiosity, problem-solving, and the confidence to
                  bring ideas to life.
                </p>
              </div>

              <div className="bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 hover:border-emerald-400/50 transition-colors p-8 text-center" data-id="element-193" data-mp="3tdd4jf6r8f42">
                <div className="w-14 h-14 rounded-full bg-emerald-400/20 flex items-center justify-center mx-auto mb-5" data-id="element-194" data-mp="18huk4uox0cr">
                  <GraduationCap className="w-7 h-7 text-emerald-300" data-id="element-195" data-mp="1hpqdbdaj88aw" />
                </div>
                <h3 className="text-xl font-bold text-white mb-2" data-id="element-196" data-mp="1hnx69ww0bm2d">
                  Future Ready
                </h3>
                <p className="text-slate-400 text-sm" data-id="element-197" data-mp="1qqoi3xssojuj">
                  Preparing youth with the skills they'll need to succeed in
                  school, careers, and life.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="pb-24" data-id="element-198" data-mp="2eg0sv23rszyy">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-199" data-mp="2eey0squporhg">
            <div className="bg-gradient-to-br from-emerald-500/20 via-emerald-600/10 to-slate-900/40 backdrop-blur rounded-3xl border border-emerald-400/30 p-12 text-center" data-id="element-200" data-mp="29h5zj686ft0l">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-201" data-mp="k3t0nwiu2x6v">
                Join Us in Building Brighter Futures
              </h2>
              <p className="text-lg text-slate-300 mb-2" data-id="element-202" data-mp="3qbjx4nw5b6ok">
                Every child in our community deserves a chance to thrive.
              </p>
              <p className="text-slate-400" data-id="element-203" data-mp="3ubu2byc45t2d">
                More information about how to support and get involved is coming
                soon.
              </p>
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-204" data-mp="37e8viwn1k15y" />
    </div>;
}